var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_vm._v("General Settings")])
}
var staticRenderFns = []

export { render, staticRenderFns }